import httpClient from './httpClient';
import { getUserData } from '../utils/auth';

class CompaniesService {
  // Company profile for authenticated company
  async getCompanyProfile() {
    try {
      const response = await httpClient.get('/api/company/profile');
      return response;
    } catch (error) {
      console.error('CompaniesService: Error in getCompanyProfile:', error);
      throw error;
    }
  }
            // Get all companies with filters and pagination
          async getCompanies(params = {}) {
            try {
              const queryParams = new URLSearchParams();

              // Add search parameter
              if (params.search) {
                queryParams.append('search', params.search);
              }

              // Add user_id parameter
              if (params.user_id) {
                queryParams.append('user_id', params.user_id);
              }

              // Add pagination parameters
              if (params.per_page) {
                queryParams.append('per_page', params.per_page);
              }

              if (params.page) {
                queryParams.append('page', params.page);
              }

              const queryString = queryParams.toString();
              const url = `/api/admin/companies${queryString ? `?${queryString}` : ''}`;

              console.log('CompaniesService: Making request to', url);
              const response = await httpClient.get(url);
              console.log('CompaniesService: Raw response from httpClient:', response);
              console.log('CompaniesService: Response type:', typeof response);
              console.log('CompaniesService: Response keys:', Object.keys(response || {}));
              console.log('CompaniesService: Response.data type:', typeof response?.data);
              console.log('CompaniesService: Response.data keys:', Object.keys(response?.data || {}));

              return response;
            } catch (error) {
              console.error('CompaniesService: Error in getCompanies:', error);
              throw error; // Throw the error so the component can handle it
            }
          }

  // Get company by ID
  async getCompanyById(id) {
    try {
      console.log('CompaniesService: Making request to get company by ID:', id);
      const response = await httpClient.get(`/api/admin/companies/${id}`);
      console.log('CompaniesService: Raw response from httpClient:', response.data);
      
      return response;
    } catch (error) {
      console.error('CompaniesService: Error in getCompanyById:', error);
      throw error; // Throw the error so the component can handle it
    }
  }

  // Create new company
  async createCompany(companyData) {
    try {
      console.log('CompaniesService: Creating new company:', companyData);
      const response = await httpClient.post('/api/admin/companies', companyData);
      console.log('CompaniesService: Raw response from httpClient:', response);
      
      return response;
    } catch (error) {
      console.error('CompaniesService: Error in createCompany:', error);
      throw error; // Throw the error so the component can handle it
    }
  }

  // Get users dropdown for companies (returns [{id, name}])
  async getUsersDropdown() {
    try {
      const response = await httpClient.get('/api/admin/companies/dropdown');
      return response;
    } catch (error) {
      console.error('CompaniesService: Error in getUsersDropdown:', error);
      throw error;
    }
  }

  // Company branches
  async getCompanyBranches(companyId, params = {}) {
    try {
      const query = new URLSearchParams({ company_id: companyId, ...params }).toString();
      let base = '/api/admin/company-branches';
      try {
        const u = getUserData();
        if (u && (u.logo || typeof u.user_id !== 'undefined')) base = '/api/company/company-branches';
      } catch {}
      const response = await httpClient.get(`${base}${query ? `?${query}` : ''}`);
      return response;
    } catch (error) {
      console.error('CompaniesService: Error in getCompanyBranches:', error);
      throw error;
    }
  }

  async createCompanyBranch(data) {
    try {
      let endpoint = '/api/admin/company-branches';
      try {
        const u = getUserData();
        if (u && (u.logo || typeof u.user_id !== 'undefined')) endpoint = '/api/company/company-branches';
      } catch {}
      return await httpClient.post(endpoint, data);
    } catch (error) {
      console.error('CompaniesService: Error in createCompanyBranch:', error);
      throw error;
    }
  }

  async updateCompanyBranch(id, data) {
    try {
      let endpoint = `/api/admin/company-branches/${id}`;
      try {
        const u = getUserData();
        if (u && (u.logo || typeof u.user_id !== 'undefined')) endpoint = `/api/company/company-branches/${id}`;
      } catch {}
      return await httpClient.post(endpoint, data);
    } catch (error) {
      console.error('CompaniesService: Error in updateCompanyBranch:', error);
      throw error;
    }
  }

  async deleteCompanyBranch(id) {
    try {
      let endpoint = `/api/admin/company-branches/${id}`;
      try {
        const u = getUserData();
        if (u && (u.logo || typeof u.user_id !== 'undefined')) endpoint = `/api/company/company-branches/${id}`;
      } catch {}
      return await httpClient.delete(endpoint);
    } catch (error) {
      console.error('CompaniesService: Error in deleteCompanyBranch:', error);
      throw error;
    }
  }

  // Update company
  async updateCompany(id, companyData) {
    try {
      console.log('CompaniesService: Updating company:', id, companyData);
      
      let requestData;
      let isCompanyAuth = false;
      try {
        const u = getUserData();
        isCompanyAuth = !!(u && (u.logo || typeof u.user_id !== 'undefined'));
      } catch {}
      
      // Check if we have files to upload or URL strings to send
      const hasFileOrUrl = (companyData.logo && (companyData.logo instanceof File || typeof companyData.logo === 'string')) ||
                           (companyData.cover && (companyData.cover instanceof File || typeof companyData.cover === 'string'));
      if (hasFileOrUrl) {
        // Send as FormData for file uploads
        const formData = new FormData();
        formData.append('name', companyData.name);
        formData.append('description', companyData.description);
        formData.append('email', companyData.email);
        formData.append('phone', companyData.phone);
        formData.append('mode', companyData.mode || 'light');
        formData.append('lang', companyData.lang || 'en');
        formData.append('mute_notification', companyData.mute_notification || 0);
        formData.append('accepts_points', companyData.accepts_points ? 1 : 0);
        formData.append('is_replaceable', companyData.is_replaceable ? 1 : 0);
        formData.append('is_refundable', companyData.is_refundable ? 1 : 0);
        if (!isCompanyAuth) {
          formData.append('user_id', companyData.user_id);
        }
        if (companyData.password) {
          formData.append('password', companyData.password);
          if (isCompanyAuth) {
            formData.append('password_confirmation', companyData.password);
            if (companyData.old_password) {
              formData.append('old_password', companyData.old_password);
            }
          }
        }
        
        // Handle logo: if it's a File, append it; if it's a URL string, append as URL
        if (companyData.logo) {
          if (companyData.logo instanceof File) {
            formData.append('logo', companyData.logo);
          }
        }
        
        // Handle cover: if it's a File, append it; if it's a URL string, append as URL
        if (companyData.cover) {
          if (companyData.cover instanceof File) {
            formData.append('cover', companyData.cover);
          }
        }
        
        requestData = formData;
        console.log('CompaniesService: Updating with FormData and files');
        
        // Log FormData contents for debugging
        for (let [key, value] of formData.entries()) {
          console.log(`CompaniesService: FormData entry - ${key}:`, value);
        }
      } else {
        // Send as JSON for text-only data
        requestData = {
          name: companyData.name,
          description: companyData.description,
          email: companyData.email,
          phone: companyData.phone,
          mode: companyData.mode || 'light',
          lang: companyData.lang || 'en',
          mute_notification: companyData.mute_notification || 0,
          accepts_points: companyData.accepts_points ? 1 : 0,
          is_replaceable: companyData.is_replaceable ? 1 : 0,
          is_refundable: companyData.is_refundable ? 1 : 0,
        };
        if (!isCompanyAuth) {
          requestData.user_id = companyData.user_id;
        }
        if (companyData.password) {
          requestData.password = companyData.password;
          if (isCompanyAuth) {
            requestData.password_confirmation = companyData.password;
            if (companyData.old_password) {
              requestData.old_password = companyData.old_password;
            }
          }
        }
        // Handle logo and cover URLs if they are strings
        if (companyData.logo && typeof companyData.logo === 'string' && companyData.logo.trim()) {
          requestData.logo = companyData.logo;
        }
        if (companyData.cover && typeof companyData.cover === 'string' && companyData.cover.trim()) {
          requestData.cover = companyData.cover;
        }
        console.log('CompaniesService: Updating with JSON without files');
      }

      console.log('CompaniesService: Update request data type:', requestData instanceof FormData ? 'FormData' : 'JSON');
      console.log('CompaniesService: Update request data:', requestData);
      // Use /company endpoint for company-auth; admins use /admin/companies/{id}
      let endpoint = `/api/admin/companies/${id}`;
      if (isCompanyAuth) {
        endpoint = '/api/company/profile';
      }

      const response = await httpClient.post(endpoint, requestData);
      return response;
    } catch (error) {
      console.error('CompaniesService: Error in updateCompany:', error);
      throw error; // Throw the error so the component can handle it
    }
  }

  // Delete company
  async deleteCompany(id) {
    try {
      console.log('CompaniesService: Deleting company:', id);
      const response = await httpClient.delete(`/api/admin/companies/${id}`);
      console.log('CompaniesService: Raw response from httpClient:', response);
      
      return response;
    } catch (error) {
      console.error('CompaniesService: Error in deleteCompany:', error);
      throw error; // Throw the error so the component can handle it
    }
  }
}

export default new CompaniesService();
